import RadioGroup from "components/atoms/RadioGroup";

export default function RadioGroupRedux({
	input,
	handleBlur,
	handleFocus,
	RadioGroupProps,
	meta: { error, touched, invalid },
	...rest
}: any) {
	return (
		<RadioGroup
			{...RadioGroupProps}
			{...rest}
			{...input}
			helperText={touched && invalid && error}
			error={touched && invalid && error && true}
			onBlur={(e) => {
				handleBlur?.(e);
				e.preventDefault();
			}}
			onFocus={(e) => {
				handleFocus?.(e);
				e.preventDefault();
			}}
		/>
	);
}
